export default __webpack_public_path__ + "static/media/feather.65e8cac7.svg";